export default __webpack_public_path__ + "static/media/image_example.30d111d2.svg";